module.exports = __webpack_public_path__ + "img/setting.9e4889d1.svg";